import { Button } from '@ekhodealer/ekho-common/rev';

interface FallbackProps {
	error: unknown;
	resetErrorBoundary: () => void;
}

export default function AppErrorFallback({ error, resetErrorBoundary }: FallbackProps) {
	return (
		<div role='alert' style={{ padding: 16 }}>
			<div>
				<div style={{ marginTop: 12 }}>
					<Button onPress={resetErrorBoundary}>Try again</Button>
				</div>
				{process.env.NODE_ENV !== 'production' && (
					<pre style={{ marginTop: 16, whiteSpace: 'pre-wrap' }}>
						{(error as Error)?.stack ?? ''}
					</pre>
				)}
			</div>
		</div>
	);
}
